import {JOB_LIST} from '../testing/TestingDataSH26';

// helper functions

function FilterJobs(type) {
    return JOB_LIST.filter(function (job) {
        return job.printingStatus === type;
    })
}

function GetFullList(type1, type2) {
    return JOB_LIST.filter(function (job) {
        return job.printingStatus === type1 || job.printingStatus === type2;
    })
}

function FilterJobsYear(type, year) {
    return JOB_LIST.filter(function (job) {
        return job.printingStatus === type && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function FilterJobsMonth(type, month, year) {
    return JOB_LIST.filter(function (job) {
        return job.printingStatus === type && new Date(job.dates.enquiryReceived).getMonth() === month
            && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function countJobs() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    return {
        currentJobCountYear: FilterJobsYear("INCOMPLETE", year).length,
        completeJobCountYear: FilterJobsYear("COMPLETE", year).length,

        currentJobCountMonth: FilterJobsMonth("INCOMPLETE", month, year).length,
        completeJobCountMonth: FilterJobsMonth("COMPLETE", month, year).length,
    }
}

// reducers

export function jobCountSkimReducer(state = countJobs(), action) {
    switch (action.type) {
        case 'jobCountSkimReducer/UPDATE':
            return countJobs();
        default:
            return state;
    }
}

export function SortReducerIncomplete(state, action) {
    switch (action.type) {
        case 'print/jobSort/SORT_NEW':
            let jobsList = FilterJobs("INCOMPLETE");
            jobsList.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
          
            return jobsList;
        case 'print/jobSort/SORT_OLD':
            let jobsListOldest = FilterJobs("INCOMPLETE");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'print/jobSort/SORT_AZ':
            let jobsListAZ = FilterJobs("INCOMPLETE");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return FilterJobs("INCOMPLETE");
    }
}

export function SortReducerComplete(state, action, jobType) {
    switch (action.type) {
        case 'print/jobSort/SORT_NEW':
            let jobsListNew = FilterJobs("COMPLETE");
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'print/jobSort/SORT_OLD':
            let jobsListOldest = FilterJobs("COMPLETE");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'print/jobSort/SORT_AZ':
            let jobsListAZ = FilterJobs("COMPLETE");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return FilterJobs("COMPLETE");
    }
}

export function SortReducerFull(state, action, jobType) {
    switch (action.type) {
        case 'print/jobSort/SORT_NEW':
            let jobsListNew = GetFullList("COMPLETE", "INCOMPLETE");
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'print/jobSort/SORT_OLD':
            let jobsListOldest = GetFullList("COMPLETE", "INCOMPLETE");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'print/jobSort/SORT_AZ':
            let jobsListAZ = GetFullList("COMPLETE", "INCOMPLETE");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return GetFullList("COMPLETE", "INCOMPLETE");
    }
}


export function SearchReducerNew(state = "search", action) {
    switch (action.type) {
        case 'print/new/SEARCH': {
            let returnList = []
            let jobs = FilterJobs(action.jobType)

            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerComplete(state = "search", action) {
    switch (action.type) {
        case 'print/complete/SEARCH': {
            let returnList = []
            let jobs = FilterJobs("COMPLETE");
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerFull(state = "search", action) {
    switch (action.type) {
        case 'print/full/SEARCH': {
            let returnList = []
            let jobs = GetFullList("COMPLETE", "INCOMPLETE");
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
} 